export const DURATION_ZERO = 'P0D'
export const DURATION_NONE = 'PT0S'
export const DURATION_30S = 'PT30S'
export const DURATION_1M = 'PT1M'
export const DURATION_2M = 'PT2M'
export const DURATION_3M = 'PT3M'
export const DURATION_4M = 'PT4M'
export const DURATION_5M = 'PT5M'
export const DURATION_10M = 'PT10M'
export const DURATION_15M = 'PT15M'
export const DURATION_20M = 'PT20M'
export const DURATION_30M = 'PT30M'
export const DURATION_45M = 'PT45M'
export const DURATION_1H = 'PT1H'
export const DURATION_2H = 'PT2H'
export const DURATION_3H = 'PT3H'
export const DURATION_6H = 'PT6H'
export const DURATION_9H = 'PT9H'
export const DURATION_12H = 'PT12H'
export const DURATION_15H = 'PT15H'
export const DURATION_ALWAYS = 'INFINITE'
